import React from 'react';
import { useI18n } from '../../utils/i18n';
import { useFeature } from '../../utils/featuresCache';
import { useBenutzerEinstellungen } from '../../services/benutzerEinstellungen';
import { REITER, waehlbareReiter } from '../header/reiter';
import useSofortSpeichern from './useSofortSpeichern';
import './einstellungen.css';

// #568: Abschnitt „Kopfleiste“ im Einstellungs-Dialog.
//
//   - Reiter: einer je Reiter, den die Rolle zeigt (header/reiter.js). Feste
//     Reiter (Dashboard) stehen angehakt und gesperrt da. Gespeichert wird die
//     Liste der AUSGEBLENDETEN ids. ids, die hier gerade nicht stehen (Rolle
//     gewechselt, Reiter eines späteren Release), bleiben in der Liste.
//   - Symbol und Text oder nur Symbol (`reiterNurSymbol`).
//   - Kontaktsuche (`kontaktsuche: false` blendet sie aus). Nur für die, die
//     sie überhaupt sehen: Kundenstamm an, Manager oder Admin.
export default function KopfleisteWahl({ user }) {
  const { t } = useI18n();
  const einstellungen = useBenutzerEinstellungen();
  const kundenstamm = useFeature('customers');
  const { speichert, speichere } = useSofortSpeichern();

  const bereit = !!einstellungen && !speichert;
  const ausgeblendet = Array.isArray(einstellungen?.reiter) ? einstellungen.reiter : [];
  const nurSymbol = einstellungen?.reiterNurSymbol === true;
  const kontaktsucheMoeglich = kundenstamm && !!(user?.dbUser?.isManager || user?.dbUser?.isAdmin);

  const schalteReiter = (id, an) => {
    const rest = ausgeblendet.filter((x) => x !== id);
    speichere({ reiter: an ? rest : [...rest, id] });
  };

  const feste = REITER.filter((r) => r.fest);
  const name = (r) => t(r.textKey, r.text);

  return (
    <div className="einst-kopfleiste">
      <fieldset className="einst-gruppe">
        <legend className="einst-unterkopf">{t('einstellungen.reiter', 'Reiter')}</legend>
        <div className="einst-schalterliste">
          {feste.map((r) => (
            <label key={r.id} className="einst-schalter" title={t('einstellungen.reiterFest', 'Startseite, immer sichtbar')}>
              <input type="checkbox" checked disabled />
              <span>{name(r)}</span>
            </label>
          ))}
          {waehlbareReiter(user).map((r) => (
            <label key={r.id} className="einst-schalter">
              <input
                type="checkbox"
                checked={!!einstellungen && !ausgeblendet.includes(r.id)}
                disabled={!bereit}
                onChange={(e) => schalteReiter(r.id, e.target.checked)}
              />
              <span>{name(r)}</span>
            </label>
          ))}
        </div>
      </fieldset>

      <fieldset className="einst-gruppe">
        <legend className="einst-unterkopf">{t('einstellungen.reiterAnzeige', 'Darstellung der Reiter')}</legend>
        <div className="einst-schalterliste">
          <label className="einst-schalter">
            <input type="radio" name="einst-reiter-anzeige" checked={!!einstellungen && !nurSymbol} disabled={!bereit}
              onChange={() => speichere({ reiterNurSymbol: null })} />
            <span>{t('einstellungen.symbolUndText', 'Symbol und Text')}</span>
          </label>
          <label className="einst-schalter">
            <input type="radio" name="einst-reiter-anzeige" checked={!!einstellungen && nurSymbol} disabled={!bereit}
              onChange={() => speichere({ reiterNurSymbol: true })} />
            <span>{t('einstellungen.nurSymbol', 'Nur Symbol')}</span>
          </label>
        </div>
      </fieldset>

      {kontaktsucheMoeglich && (
        <label className="einst-schalter">
          <input
            type="checkbox"
            checked={!!einstellungen && einstellungen.kontaktsuche !== false}
            disabled={!bereit}
            // An ist die Vorgabe: einschalten nimmt den Schlüssel heraus
            onChange={(e) => speichere({ kontaktsuche: e.target.checked ? null : false })}
          />
          <span>{t('einstellungen.kontaktsuche', 'Kontaktsuche in der Kopfleiste')}</span>
        </label>
      )}
    </div>
  );
}
